import BlobImage from "../../../components/BlobImage/BlobImage";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import "./Index.css";
import PopupModal from "../../../components/PopupModal/PopupModal";

const WORD_LIMIT = 500;

export default function ManagementTalk(props) {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [popupOpen, setPopupOpen] = useState(false);

  const current = props.managementTalks?.[activeIndex];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
  };

  // Truncate content to WORD_LIMIT words
  const getTruncatedContent = (content) => {
    if (!content) return { text: "", isTruncated: false };
    const words = content.trim().split(/\s+/);
    if (words.length <= WORD_LIMIT) {
      return { text: content, isTruncated: false };
    }
    return {
      text: words.slice(0, WORD_LIMIT).join(" ") + "...",
      isTruncated: true,
    };
  };

  const { text: displayContent, isTruncated } = getTruncatedContent(
    current?.content
  );

  const hasData = props.managementTalks && props.managementTalks.length > 0;

  const handleReadFullSpeech = (e) => {
    e.preventDefault();
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  // Render function for the full list inside the popup
  const renderFullSpeechList = () => {
    return (
      <div className="mt-popup-list">
        {props.managementTalks.map((talk, index) => (
          <div key={talk.id || index} className="mt-popup-item">
            <div className="mt-popup-item-header">
              <div className="mt-popup-author">
                {talk.image && (
                  <BlobImage
                    path={talk.image}
                    alt={talk.name}
                    className="mt-popup-avatar"
                  />
                )}
                <div className="mt-popup-author-info">
                  <h4>{talk.name}</h4>
                  <span>{talk.designation}</span>
                </div>
              </div>
              <span className="mt-popup-date">{formatDate(talk.date)}</span>
            </div>
            <p className="mt-popup-content">{talk.content}</p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="management-container">
      <div className="management-card">
        <h2 className="management-title">
          {t.managementTalk || "Management Talk"}
        </h2>

        {hasData ? (
          <>
            {/* Timeline */}
            <div className="timeline-wrapper">
              {props.managementTalks.map((talk, index) => (
                <div
                  key={talk.id}
                  className={`timeline-node ${
                    activeIndex === index ? "active" : ""
                  }`}
                  style={{
                    left:
                      props.managementTalks.length > 1
                        ? `${
                            (index / (props.managementTalks.length - 1)) * 100
                          }%`
                        : "50%",
                  }}
                  onClick={() => setActiveIndex(index)}
                >
                  {activeIndex === index ? (
                    <span className="active-dot" />
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>

            {/* Content */}
            <div className="content-header">
              <div className="author">
                {current?.image && (
                  <BlobImage path={current.image} alt={current?.name} />
                )}
                <div>
                  <h4>{current?.name}</h4>
                  <span>{current?.designation}</span>
                </div>
              </div>
              <span className="management-date">
                {formatDate(current?.date)}
              </span>
            </div>

            <p className="management-description">{displayContent}</p>

       
              <div className="read-more">
                <a href="#" onClick={handleReadFullSpeech}>
                  {t.readFullSpeech || "Read Full Speech"}
                </a>
              </div>

          </>
        ) : (
          <div className="management-empty">
            <div className="bird-wrapper">
              <svg
                width="80"
                height="90"
                viewBox="0 0 80 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse cx="40" cy="45" rx="28" ry="30" fill="#6B4EAD" />
                <ellipse cx="40" cy="12" rx="8" ry="12" fill="#6B4EAD" />
                <circle cx="40" cy="8" r="5" fill="#8B6EC9" />
                <ellipse cx="32" cy="38" rx="6" ry="7" fill="white" />
                <ellipse cx="48" cy="38" rx="6" ry="7" fill="white" />
                <circle cx="33" cy="39" r="3" fill="#333" />
                <circle cx="49" cy="39" r="3" fill="#333" />
                <circle cx="34" cy="38" r="1" fill="white" />
                <circle cx="50" cy="38" r="1" fill="white" />
                <ellipse cx="40" cy="52" rx="5" ry="4" fill="#FFB74D" />
                <ellipse cx="18" cy="50" rx="10" ry="15" fill="#8B6EC9" />
                <ellipse cx="62" cy="50" rx="10" ry="15" fill="#8B6EC9" />
                <path
                  d="M32 75 L28 85 M32 75 L32 85 M32 75 L36 85"
                  stroke="#FF8C00"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  d="M48 75 L44 85 M48 75 L48 85 M48 75 L52 85"
                  stroke="#FF8C00"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <p className="management-empty-text"></p>
          </div>
        )}
      </div>

      {/* Full Speech Popup - uses render mode */}
      <PopupModal
        open={popupOpen}
        title={t.managementTalk || "Management Talk"}
        onClose={handleClosePopup}
        onOk={handleClosePopup}
        wide={true}
        render={true}
        renderData={renderFullSpeechList}
      />
    </div>
  );
}